export const MAX_CHARACTERS = 255;

export const FILE_UPLOAD_CONFIGURATION = {
  FILE_SIZE_MB: Number(process.env.REACT_APP_MAX_FILE_SIZE_MB) || 10,
  MAX_FILES: Number(process.env.REACT_APP_MAX_FILES) || 10,
};

export enum REQUEST_STATUS {
  Processing = 1,
  Completed = 2,
  Failed = 3,
  Cancelling = 4,
  Cancelled = 5,
}
